const zhCN = {
  readCardWarning: '读卡警告',

  readingIDCard: '读取身份证信息中...',
  readIDCardSuccess: '身份证信息读取成功！',
  readIDCardFail: '身份证信息读取失败！',

  readingICCard: '读取门禁卡信息中...',
  readICCardSuccess: '门禁卡信息读取成功！',
  readICCardFail: '门禁卡信息读取失败！',

  webSocketInvokeFail: 'WebSocket 启用失败！',
  webSocketTip: 'WebSocket连接已经关闭，或者连接不能打开！',
  webSocketTip1: '请确认已经启动读卡程序！',
  webSocketTip2: '下载安装读卡程序后再读卡！',
  downloadReadExe: '点击下载',

  closeBtn: '关闭'
}

const enUS = {
  readCardWarning: 'Read Card Warning',

  readingIDCard: 'ID card reading...',
  readIDCardSuccess: 'Read ID card successfully!',
  readIDCardFail: 'Read ID card failed!',

  readingICCard: 'IC card reading...',
  readICCardSuccess: 'Read IC card successfully!',
  readICCardFail: 'Read IC card failed!',
  
  webSocketInvokeFail: 'WebSocket invoke failed!',
  webSocketTip: 'The WebSocket connection is closed, or the connection cannot be opened!',
  webSocketTip1: 'Please confirm that the card reader has been started!',
  webSocketTip2: 'Download and install the card reader program!',
  downloadReadExe: ' Click download',

  closeBtn: 'Close'
}

export default { zhCN, enUS }